<template>
  <div>
    <b-modal id="bv-modal-new-site" hide-footer>
      <template #modal-title>Add website</template>

      <div class="row">
        <div class="col">
            <label class="form-label pt-2 mb-2">Domain Name</label>
            <input class="form-control2" placeholder="example.com" v-model="site.name">
        </div>
      </div>

      <div class="row mt-3 pb-2">
        <div class="col mt-2 mt-md-0">
            <button v-if="updating" type="button" class="btn btn-danger submit col">
            <i class="fas fa-spinner fa-sm fa-spin mr-2 move-up"></i></button>
            <button v-else type="button" class="btn btn-danger submit col" @click="saveProfile">Save</button>
        </div>
      </div>

    </b-modal>
  </div>
</template> 

<script>
import { EventBus } from '../bus';

export default {

  data() {
    return {
      updating: false,
      site:{}
    };
  },

  methods: {

    hideModalNewSite() {
      this.$bvModal.hide('bv-modal-new-site');
    },

          clearSite() {
              this.site = {};
          },

            saveProfile() {

             this.updating = true;

              axios.post('/websites/new', {
                name: this.site.name,
              })
               .then((response) => {
                  
                   EventBus.$emit('site-created', {
                        id: response.data.site.id,
                        name: response.data.site.name,
                        code: "Not installed",
                   });
                   this.hideModalNewSite();

                }).catch((error) => {

                    this.sweetfire(error.response.data.message);

                }).finally(() => {
                    this.updating = false;
                });

          },
  },
};
</script>